import { Link, Paper, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { NavLink } from "components/navigation/NavLink";

export function DrawOrUploadMeasureFooter() {
  const { t } = useTranslation();
  const { uuid } = useParams();

  return (
    <StyledPaper elevation={0}>
      <Link component={NavLink} to={`/${uuid}/measures`}>
        {t("label.cancel")}
      </Link>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
`;
